module.exports = __webpack_public_path__ + "static/media/bg-callout.31f926ac.jpg";